import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "16",
      cy: "16",
      r: "15.6",
      fill: "#fff",
      stroke: "#CBCBCB",
      "stroke-width": ".8"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.2",
      d: "M16.017 8.426c-2.758 0-5 2.241-5 5v2.408c0 .508-.216 1.283-.474 1.717l-.959 1.591c-.592.984-.183 2.075.9 2.442 3.592 1.2 7.467 1.2 11.059 0a1.67 1.67 0 0 0 .9-2.442l-.959-1.591c-.25-.434-.467-1.209-.467-1.717v-2.408c0-2.75-2.25-5-5-5Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.2",
      d: "M17.56 8.667a5.63 5.63 0 0 0-3.083 0 1.65 1.65 0 0 1 1.541-1.05c.7 0 1.3.434 1.542 1.05"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-miterlimit": "10",
      "stroke-width": "1.2",
      d: "M18.516 21.883c0 1.375-1.125 2.5-2.5 2.5a2.5 2.5 0 0 1-1.767-.733 2.5 2.5 0 0 1-.733-1.767"
    }, null, -1)
  ]))]))
}
export default { render: render }